import React from 'react';
import styles from './Top.module.css';

import { Button } from '@mantine/core';

import Arrow from '@icons/Arrow_gray.svg';
import Check from '@icons/Check.svg';
import Publish from '@icons/Publish.svg';
import IcomButton from '@icons/IcomButton.svg';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import useAuth from '@hooks/useAuth';

const Top = ({ place, form, onSubmit, vip, isOrganization, organization, isCalledFromMain }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ currentUser }] = useAuth();

  const handlePrev = () => {
    if (isOrganization) {
      navigate(`/organizations/${isOrganization}/?page=places`);
      return;
    }
    if (isCalledFromMain) {
      navigate(-1);
      // navigate(`/organizations?page=places`);
      return;
    }
    
    navigate(-1);
  }

  const handleErrors = (errors) => {
    if (!errors) {
      return;
    }

    errors.forEach(error => {
      switch (error.code) {
        case 'P010':
          form.setErrors({
            image: t('errors.image')
          })

          break;

        default:
          break;
      }
    })
  }

  const handleSave = async () => {
    const { hasErrors } = form.validate();

    if (!hasErrors) {
      const values = form.getValues()

      const { errors } = await onSubmit(values, vip, true)
      handleErrors(errors)

      if (!errors) {
        window.gtag('event', 'action_place_save', {
          isAdmin: !!currentUser?.admin
        })
      }
    }
  }

  const handlePublish = async () => {
    const { hasErrors } = form.validate();

    if (!hasErrors) {
      const values = form.getValues()

      const { errors } = await onSubmit(values, true)
      handleErrors(errors)

      if (!errors) {
        window.gtag('event', 'action_place_publish', {
          isAdmin: !!currentUser?.admin
        })
      }
    }
  }

  const handleUnPublish = async () => {
    const { hasErrors } = form.validate();

    if (!hasErrors) {
      const values = form.getValues()

      const { errors } = await onSubmit(values, false)
      handleErrors(errors)

      if (!errors) {
        window.gtag('event', 'action_place_unpublish', {
          isAdmin: !!currentUser?.admin
        })
      }
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        {isCalledFromMain ? (
            <div className={styles.breadcrumbs}>
              <div className={styles.back} onClick={handlePrev}>
                <img src={IcomButton}/>
              </div>

              <div className={styles.currentDiv2}>
                {place.place.placeName}
              </div>
            </div>
        ) : (<div className={styles.breadcrumbs}>
          <div className={styles.prev} onClick={handlePrev}>
            {isOrganization ? organization : t('places.title')}
          </div>

          <div className={styles.arrow}>
            <img src={Arrow}/>
          </div>

          <div className={styles.current}>
            {place.place.placeName}
          </div>
        </div>)
        }


        <div className={styles.status}>
          <div className={styles.statusTitle}>
            {t('status')}
          </div>

          <div className={styles.statusName} style={{color: vip ? '#68BF61' : '#3A86FF'}}>
            {vip ? t('status.published') : t('status.unpublished')}
          </div>
        </div>
      </div>

      <div className={styles.rightContent}>
        <div className={styles.right}>
          <Button
            leftSection={<img src={Check} />}
            onClick={handleSave}
          >
            {t('save')}
          </Button>

          {!vip && (
            <Button
              onClick={handlePublish}
              leftSection={<img src={Publish} />}
            >
              {t('publish')}
            </Button>
          )}

          {vip && (
            <Button
              className={styles.unpublish}
              onClick={handleUnPublish}
            >
              {t('unpublish')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Top;
